export default "__VITE_ASSET__clYXeWaR__"